import { render, staticRenderFns } from "./IconButtonBack.vue?vue&type=template&id=ee208c06&scoped=true&"
import script from "./IconButtonBack.vue?vue&type=script&lang=js&"
export * from "./IconButtonBack.vue?vue&type=script&lang=js&"
import style0 from "./IconButtonBack.vue?vue&type=style&index=0&id=ee208c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee208c06",
  null
  
)

export default component.exports